import React, { useMemo } from "react";
import DataTable from '@/components/DataTable'
import styled from "styled-components";

const RankTable = ({data}) => {
  const head = useMemo(() => {
    return [
      {
        title: <div className="head-title title-first">昵称</div>
      },
      {
        title: <div className="head-title">发送邀请</div>
      },
      {
        title: <div className="head-title">邀请人数</div>
      },
      {
        title: <div className="head-title">获得奖励</div>
      }
    ]
  }, []);
  const column = useMemo(() => {
    return [
      {
        renderItem: (item, index) => {
          return (
            <div className="avatar-wrap">
              <img className="rank-avatar" alt="" src={item.avatar} />
              <div className="rank-name">{item.nickname}</div>
            </div>
          )
        }
      },
      {
        renderItem: (item, index) => {
          return (
            <div className="invite-value">{item.sendInviteUrlCount || 0}次</div>
          )
        }
      },
      {
        renderItem: (item) => {
          return (
            <div className="invite-value">{item.inviteCount || 0}人</div>
          )
        }
      },
      {
        renderItem: (item) => {
          return (
            <div className="invite-value">{item.bonus}元</div>
          )
        }
      }
    ]
  }, []);

  if (!Array.isArray(data) || data.length === 0) {
    return null;
  }

  return (
    <Container className="rank-table">
      <DataTable
        data={data}
        head={head}
        columns={column}
      />
    </Container>
  )
}

export default React.memo(RankTable)

const Container = styled.div`
  padding: 20px 15px 0;
  font-size: 12px;
  font-weight: 500;
  color: #000000;
  .invite-value {
    text-align: center;
  }
  .rank-avatar {
    width: 26px;
    height: 26px;
    border-radius: 13px;
    margin-right: 6px;
  }
  .avatar-wrap {
    display: flex;
    align-items: center;
  }
  .rank-name {
    max-width: 80px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .head-title {
    padding-bottom: 20px;
  }
  .title-first {
    text-align: left;
    padding-left: 6px;
    box-sizing: border-box;
  }
  .avatar-wrap,
  .invite-value{
    margin-bottom: 10px;
  }

  .body-tr:last-child .avatar-wrap {
    margin-bottom: 0px;
  }
  .body-tr:last-child .invite-value {
    margin-bottom: 0px;
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_42/components/rank-table.js